export default [
  {
    path: 'user',
    name: 'userlayout',
    component: () => import('@/layouts/UserLayout.vue'),
    children: [
      {
        path: 'password',
        name: 'change-password',
        component: () => import('@/views/user/ChangePassword.vue'),
      },
    ],
  },
];
